'use client';

import { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

interface VoucherAccordionProps {
  isOpen: boolean;
  onToggle: () => void;
  badge: ReactNode;
  title: string;
  shortDescription: string;
  validity: string;
  accent: string;
  children: ReactNode;
}

export function VoucherAccordion({
  isOpen,
  onToggle,
  badge,
  title,
  shortDescription,
  validity,
  accent,
  children,
}: VoucherAccordionProps) {
  return (
    <section
      className="rounded-3xl bg-white shadow-lg border border-gray-100 overflow-clip transition-shadow hover:shadow-xl"
      style={{ borderTop: `3px solid ${accent}` }}
    >
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full px-5 sm:px-8 py-6 flex items-start gap-4 text-left cursor-pointer"
      >
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium mb-3" style={{ backgroundColor: `${accent}15`, color: accent }}>
            {badge}
          </div>
          <h2 className="font-poppins text-xl sm:text-2xl md:text-3xl font-bold text-[#2c1810] mb-2 break-words">{title}</h2>
          <p className="text-sm sm:text-base text-gray-600 mb-2">{shortDescription}</p>
          <p className="text-xs text-gray-400">{validity}</p>
        </div>
        <ChevronDown
          className={`w-6 h-6 text-gray-400 shrink-0 mt-1 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {isOpen && (
        <div className="px-5 sm:px-8 pb-8 border-t border-gray-100 pt-6 animate-in fade-in slide-in-from-top-2 duration-300">
          {children}
        </div>
      )}
    </section>
  );
}
